export default __webpack_public_path__ + "static/media/no-symbol.f2175883.png";